import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { PersonalInfoNodeView } from "@/components/editor/nodeviews/PersonalInfoNodeView";

/**
 * CV header block — name, headline, contact line. Renders into the
 * \noindent\textbf{\LARGE …} preamble that LaTeXExportService /
 * RenderService emit; class-agnostic so it works under article,
 * report, book, or moderncv.
 */
export const PersonalInfoBlock = Node.create({
  name: "personalInfoBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      name: { default: "" },
      headline: { default: "" },
      email: { default: "" },
      phones: { default: [] as Array<{ label?: string; number: string }> },
      homepage: { default: "" },
      location: { default: "" },
      socials: { default: [] as Array<{ network: string; handle: string; url?: string }> },
      extra: { default: "" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="personal-info-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "personal-info-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(PersonalInfoNodeView);
  },
});
